import { Flex, SegmentedControl, Text } from '@mantine/core';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ReportData, ReportFormat } from '../SuitabilityFlow';
import { SettingsRow } from '../SettingsRow';
import SelectSuitabilityReportTemplateStep from 'src/UI/drawer-flow/SelectSuitabilityReportTemplateStep';

export default function SuitabilitySelectTemplateStep(props: StepProps<ReportData>) {
  const { data, setData } = props;
  const { flagEnabledSuitabilityreportformat } = useFlags();

  const handleToggle = (key: string, value: boolean) => {
    setData({ ...data, [key]: value });
  };

  return (
    <SelectSuitabilityReportTemplateStep
      {...props}
      type="SUITABILITY_REPORT"
      renderExpandedContent={() =>
        flagEnabledSuitabilityreportformat ? (
          <Flex direction="column" gap="xs">
            <Text size="sm" fw={500} c="gray.8">
              Report format
            </Text>
            <SegmentedControl
              value={data.reportFormat}
              onChange={value => setData({ ...data, reportFormat: value as ReportFormat })}
              data={[
                { label: 'Letter', value: 'LETTER' },
                { label: 'Report', value: 'REPORT' },
              ]}
              fullWidth
            />
            <Text size="xs" c="gray.6">
              {data.reportFormat === 'LETTER'
                ? "Make sure the client's address is set in their profile"
                : 'Report includes a title page and table of contents'}
            </Text>
          </Flex>
        ) : (
          <>
            <SettingsRow
              titleColor={'gray.8'}
              title="Add title page"
              checked={data.addTitlePage}
              onChange={value => handleToggle('addTitlePage', value)}
              titleSize={'sm'}
              showDivider
            />
            <SettingsRow
              titleColor={'gray.8'}
              title="Add table of contents"
              checked={data.addTableOfContents}
              onChange={value => handleToggle('addTableOfContents', value)}
              titleSize={'sm'}
            />
          </>
        )
      }
    />
  );
}
